import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-card')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative pt-8 pb-8 px-4 sm:px-6 lg:px-8 overflow-hidden bg-gradient-to-b from-cream to-cream-secondary" data-id="element-21">
      <div className="max-w-4xl mx-auto text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-23">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-text-dark leading-tight mb-6" data-id="element-24">
            "Esa mirada de miedo en sus ojos...{' '}
            <br className="hidden md:block" data-id="element-25" />
            <span className="text-gold-dark italic font-normal" data-id="element-26">
              detén el grito antes de que rompa su confianza para siempre."
            </span>
          </h1>

          <div className="flex justify-center items-center gap-4 my-8" data-id="element-27">
            <div className="h-px w-16 bg-gold-light" data-id="element-28"></div>
            <div className="w-2 h-2 rounded-full bg-gold" data-id="element-29"></div>
            <div className="h-px w-16 bg-gold-light" data-id="element-30"></div>
          </div>

          <p className="text-lg sm:text-xl text-text-medium max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-31">
            La guía de emergencia para madres que aman a sus hijos pero odian
            sus propias reacciones.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative max-w-md mx-auto mb-12" data-id="element-32">
          <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform -translate-y-4 scale-90" data-id="element-33"></div>
          <img src="https://cdn.magicpatterns.com/uploads/hDUUN3WxeAvF2mT9CC7vYv/Cover.png" alt="El Método de la Pausa Consciente - Portada del libro" className="relative z-10 w-full h-auto rounded-lg shadow-2xl transform transition-transform duration-700 hover:scale-[1.02]" data-id="element-34" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-35">
          <button onClick={scrollToOffer} className="w-full sm:w-auto px-8 py-5 bg-gold hover:bg-gold-dark text-text-dark font-bold text-lg sm:text-xl rounded-full shadow-[0_8px_20px_rgba(197,165,90,0.3)] hover:shadow-[0_12px_25px_rgba(197,165,90,0.4)] transform transition-all duration-300 hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-gold-light" aria-label="Obtener acceso inmediato" data-id="element-36">
            OBTENER ACCESO INMEDIATO
          </button>
          <p className="mt-4 text-sm text-text-medium italic" data-id="element-37">
            Acceso inmediato. Lectura rápida.
          </p>
        </motion.div>
      </div>
    </section>;
}